import { render, staticRenderFns } from "./domainButtons.vue?vue&type=template&id=04d4ccbf&scoped=true"
import script from "./domainButtons.vue?vue&type=script&lang=js"
export * from "./domainButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4ccbf",
  null
  
)

export default component.exports